import {
  Image,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Box,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { ProspectType } from '~/lib/homes/profile/prospect';

export const ProspectBody = ({ prospect }: { prospect: ProspectType }) => {
  const { prospectUrl, imageUrl, text } = prospect;

  return (
    <Box
      cursor="pointer"
      onClick={() => window.open(prospectUrl, '_blank')}
      pb="8"
    >
      <Box textAlign="left">
        <Image src={imageUrl} alt={text} display="inline-block" />
      </Box>
      {/* <Center>
        <Button
          leftIcon={<MdOpenInNew />}
          size="sm"
          variant="outline"
          onClick={() => window.open(prospectUrl, '_blank')}
        >
          Visa prospekt
        </Button>
      </Center> */}
    </Box>
  );
};

export const Prospect = ({ prospect }: { prospect: ProspectType }) => {
  const t = useTranslations('HomeProfile.Accordions');
  return (
    <Card borderColor="gray.200" borderWidth="1px" boxShadow="lg" rounded="xl">
      <CardHeader pb="0">
        <Heading size="xs" fontSize="lg" fontWeight="bold">
          {t('Prospect.title')}
        </Heading>
      </CardHeader>
      <CardBody m="auto" p="0">
        <ProspectBody prospect={prospect} />
      </CardBody>
    </Card>
  );
};
